import { createContext } from 'react';
export var localizationContext = /*#__PURE__*/createContext(undefined);